export const fonts = {
  heading: 'InterVariable, Inter, sans-serif',
  body: 'InterVariable, Inter, sans-serif',
}

export const fontSizes = {
  '3xs': '0.45rem',
  '2xs': '0.625rem',
  xs: '0.75rem',
  sm: '0.8125rem',
  md: '0.875rem',
  lg: '1rem',
  xl: '1.125rem',
  '2xl': '1.25rem',
  '3xl': '1.5rem',
  '4xl': '1.875rem',
  '5xl': '2.25rem',
  '6xl': '3rem',
  '7xl': '3.75rem',
  '8xl': '4.5rem',
  '9xl': '6rem',
}

export const textStyles = {
  h1: {
    fontSize: ['5xl', '6xl', '7xl'],
    fontWeight: 'extrabold',
    lineHeight: '1.2',
    letterSpacing: '-2%',
  },
  h2: {
    fontSize: ['3xl', '4xl', '5xl'],
    fontWeight: 'extrabold',
    lineHeight: '1.1',
    letterSpacing: '-1%',
  },
  h3: {
    fontSize: ['lg', 'xl'],
    fontWeight: 'extrabold',
    lineHeight: '1.1',
    letterSpacing: '-1%',
  },
  subtitle: {
    fontSize: ['lg', null, '2xl'],
    fontWeight: 'normal',
  },
}
